export default __webpack_public_path__ + "static/media/rishabh.19890adb.png";